export default "__VITE_ASSET__UY4rziEa__"